import { render } from "./JudgeCard.vue?vue&type=template&id=63aa25c8"
import script from "./JudgeCard.vue?vue&type=script&lang=js"
export * from "./JudgeCard.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__